import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator, fallback } from '@tanstack/zod-adapter'
import { ChatView } from '@/components/chat/chat-view'

const chatSearchSchema = z.object({
  conversationId: fallback(z.string().optional(), undefined),
  sandbox: fallback(z.boolean().optional(), undefined),
})

export const Route = createFileRoute('/_authenticated/chat/$agentId')({
  validateSearch: zodValidator(chatSearchSchema),
  component: ChatPage,
})

function ChatPage() {
  const { agentId } = Route.useParams()
  const { conversationId, sandbox } = Route.useSearch()
  return <ChatView agentId={agentId} conversationId={conversationId} sandbox={sandbox} />
}
